import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { diffInDays, toDate, toFullDateName } from "helpers/dateHelper";
import { Alert, Button, Card, CardActions, CardContent, CardHeader, Dialog, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { CustomersDialog } from "components/CustomersDialog/CustomersDialog";
import { useState } from "react";
import { Link } from "react-router-dom";
import { BookingStatus } from "components/BookingStatus";
import _ from "lodash";
import CustomersAutocompleteField from "components/CustomersAutocomplete/CustomersAutocomplete";
import TourpackageAutocompleteField from "components/TourpackageAutocompleteField/TourpackageAutocompleteField";
import { toCurrencyFormat } from "helpers/utils";
import { toast } from "react-toastify";
import subOrdersService from "services/admin/sub-orders.service";
import { SUB_ORDER_TYPE } from "enums/enums";

const SubOrderForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: {
    subOrder,
  },
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    getValues,
    formState: { isValid, isSubmitting, errors },
    watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      orderItems: subOrder?.orderItems || [
        {
          customerID: null,
          itemID: null,
          price: null,
          currency: "KZT",
          comment: null,
          itemType: "tourpackage"
        }
      ],
      totalAmount: subOrder?.totalAmount || 0,
      comment: subOrder?.comment || "",
      customerID: subOrder?.customerID || null,
      type: SUB_ORDER_TYPE.TOURPACKAGE
    },
  });
  const [isBuyerDialogVisible, setBuyerDialogVisible] = useState(false)
  const [isCustomersDialogVisible, setCDVisible] = useState(false)

  function recalculatetotalAmount() {
    const orderItems = getValues('orderItems') || []
    const totalAmount = orderItems.map(item => item.price).reduce((acc, curr) => acc + Number(curr), 0)
    setValue('totalAmount', totalAmount)
  }

  console.log("Bookings errors: ", errors);

  const onSubmit = async (orderInput) => {
    const isConfirmed = window.confirm('Вы точно хотите оформить заказ?')
    if (!isConfirmed) {
      return
    }
    if (!isValid) {
      // Форма не валидная
      alert('Форма не валидная')
      return false
    }
    if (isSubmitting) {
      // Данные в формачке отправляются
      return false
    }

    if (subOrder) {
      await subOrdersService.put(id, orderInput)
      toast.success("Заказ обновлен успешно!");
      navigate(`/admin/sub-orders/view/${id}`)
    } else {
      const { data: createdSubOrder } = await subOrdersService.post(orderInput, { type: SUB_ORDER_TYPE.TOURPACKAGE })
      toast.success("Заказ создан успешно!");
      navigate(`/admin/sub-orders/view/${createdSubOrder.id}`)
    }
  };

  function addCustomer() {
    setValue('orderItems', [...getValues('orderItems'), {
      customerID: null,
    }], {
      shouldValidate: true
    })
  }
  function addBuyer(customer) {
    setValue('customerID', customer.id)
    setBuyerDialogVisible(false)
  }

  function deleteOrderItem(index) {
    let prevValues = getValues('orderItems') || []
    prevValues = prevValues.filter((_, i) => i !== index)
    setValue('orderItems', prevValues, {
      shouldValidate: true
    })
    recalculatetotalAmount()
  }

  /**
   * Состояние формы
  */
  return (
    <CrudPage title={subOrder ? 'Редактирование заказа' : 'Создание заказа'}>
      <div className="m-b-32">
        {subOrder ? null :
          <Alert color="info">Чтобы создать заказ, пожалуйста:
            <ul>
              <ol>1. Выберите турпакет из списка</ol>
              <ol>2. Выберите покупателя из списка</ol>
              <ol>3. Выберите туристов из списка нажав на кнопку "Добавить туриста"</ol>
              <ol>4. При необходимости вы можете оставить заметку</ol>
              <ol>5. Проверьте данные и нажмите на кнопку создать заказ</ol>
            </ul>
          </Alert>
        }
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section id="booking-info">
          {subOrder ? <div className="m-t-32">
            <div>
              <div className="m-b-16">
                <strong>Дата создания заказа: </strong>
                <span>{subOrder.createdAt ? toDate(subOrder.createdAt) : 'Отсутсвует'}</span>
              </div>
              <div className="m-b-16">
                <strong>Дата последнего изменения: </strong>
                <span>{subOrder.updatedAt ? toDate(subOrder.updatedAt) : 'Отсутсвует'}</span>
              </div>
              <div className="m-b-16">
                <strong>Заказ оформлен сотрудником: </strong>
                <span>{subOrder.createdByMember?.name ? <Link className="color-blue" target="_blank" to={`/admin/members/view/${subOrder.createdByMember.id}`}>{subOrder.createdByMember?.name}</Link> : 'Отсутсвует'}</span>
              </div>
              <div>
                <strong>Статус заказа: </strong>
                <BookingStatus bookingStatus={subOrder.bookingStatus}></BookingStatus>
              </div>
              <div className="m-t-16 gap-2 flex">
                <strong>Оплатить до:</strong>
                <span>{toFullDateName(subOrder.tourPackage.startDate)}</span>
                <strong className='color-green'> {diffInDays(subOrder.tourPackage?.startDate, new Date()) > 0 ? `(осталось ${diffInDays(subOrder.tourPackage?.startDate, new Date())} дней)` : null}</strong>
              </div>
              <div className="m-t-16">
                <strong>Номер заказа: </strong>
                <span>#{subOrder.id}</span>
              </div>
            </div>
          </div> : <></>}
        </section>
        <Card id="customer-info" className="m-t-64">
          <CardHeader title="Данные покупателя" subheader="Покупатель не обязательно сам турист"></CardHeader>
          <CardContent>
            <Controller control={control} name="customerID" render={({ field }) => {
              return <CustomersAutocompleteField label="Покупатель" setValue={(v) => field.onChange(v.id)} />
            }} />
          </CardContent>
        </Card>
        <Card id="booking-customers" className="m-t-64">
          <CardHeader title="Данные туристов" subheader="Туристы не обязательно сам покупатель"></CardHeader>
          <CardContent>
            {getValues('orderItems').map((item, index) => {
              return <Card className="m-b-16" key={index}>
                <CardContent>
                  <CardHeader subheader={`${index + 1}-турист`}></CardHeader>
                  <input type="hidden" {...register(`orderItems[${index}].itemType`)} value="tourpackage" />
                  <div className="m-b-16">
                    <Controller control={control} rules={{ required: true }} name={`orderItems[${index}].customerID`} render={({ field }) => {
                      return <CustomersAutocompleteField label="Турист" setValue={(v) => field.onChange(v.id)} />
                    }} />
                  </div>
                  <div className="m-b-16">
                    <Controller control={control} name={`orderItems[${index}].itemID`} render={({ field }) => {
                      return <TourpackageAutocompleteField label="Турпакет" setValue={(tourpackage) => {
                        field.onChange(tourpackage.id)
                        setValue(`orderItems[${index}].price`, tourpackage.price, {
                          shouldTouch: true,
                          shouldDirty: true
                        })
                        setValue(`orderItems[${index}].currency`, "KZT")
                        recalculatetotalAmount()
                      }} />
                    }} />
                  </div>
                  <div className="m-b-16 flex gap-16">
                    <TextField {...register(`orderItems[${index}].price`)} label="Цена" type="number" InputLabelProps={{
                      shrink: true,
                    }} onChange={(e) => {
                      setValue(`orderItems[${index}].price`, e.target.value)
                      recalculatetotalAmount()
                    }} />
                    <TextField {...register(`orderItems[${index}].currency`)} label="Валюта" disabled InputLabelProps={{
                      shrink: true,
                    }} />
                    <input {...register(`orderItems[${index}].quantity`)} label="Количество" type="hidden" value={1} />
                  </div>

                  <Controller control={control} name={`orderItems[${index}].comment`} render={({ field }) => {
                    return <TextField {...field} label="Заметка" />
                  }} />
                </CardContent>
                <CardActions>
                  <Button type="button" onClick={() => deleteOrderItem(index)}>Удалить туриста из списка</Button>
                </CardActions>
              </Card>
            })}
          </CardContent>
        </Card>
        <section className="m-t-64">
          <Button type="button" onClick={addCustomer}>Добавить туриста</Button>
        </section>
        <Card id="totals" className="m-t-64">
          <CardHeader title="Общая сумма к оплате"></CardHeader>
          <CardContent>
            <div>
              <strong>Общая сумма к оплате: </strong>
              <span>{toCurrencyFormat(getValues('totalAmount'), 'KZT')}</span>
            </div>
          </CardContent>
        </Card>
        <section className="m-t-64">
          <Button type="submit" variant="contained" disabled={!isValid}>{subOrder ? 'Обновить заказ' : 'Создать заказ'}</Button>
        </section>
        <pre className="m-t-32">
          {JSON.stringify(watch(), null, 4)}
        </pre>
        <pre>
          {JSON.stringify(isValid)}
        </pre>
      </form >
      <Dialog fullWidth maxWidth="md" open={isBuyerDialogVisible} onClose={() => { setBuyerDialogVisible(false) }}>
        <CustomersDialog onSelect={addBuyer}></CustomersDialog>
      </Dialog>
      <Dialog fullWidth maxWidth="md" open={isCustomersDialogVisible} onClose={() => { setCDVisible(false) }}>
        <CustomersDialog onSelect={addCustomer} customersInput={[]}></CustomersDialog>
      </Dialog>
    </CrudPage >
  );
};
export default withRouter(
  withRemoteDataAndSpinner(SubOrderForm, (router) => {
    let requests = {}
    if (router.params.id) {
      requests['subOrder'] = () => subOrdersService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
